module.exports = __webpack_public_path__ + "media/components/assets/images/makeyourdream/image9-e74f0d2281b592c060aab938e96247a5.png";